import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PropTypes from "prop-types";
import AddTaskIcon from "@mui/icons-material/AddTask";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import useMasterApiCall from "../../../../customApiHooks/useMasterApiCall";
import { subDialogContentStyle, dialogContentTextStyle } from "components/Styles/approvalStyles";
import { selectScrollStyle, CustomPaper } from "components/Styles/globalStyles";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Stack,
  TextField,
  Alert,
  Tooltip,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  CircularProgress,
  Typography,
  Autocomplete,
  Box,
} from "@mui/material";
import Cookie from "js-cookie";
import {
  ViewButton,
  DeleteButton,
  StyledTypography,
  StyledButton,
  StyledButtonC,
  CustomTableCell,
  StyledAlert,
  StyledSnackbar,
  inputStyle,
  StyledAgGridContainer,
  StyledTableContainer,
} from "components/StyledComponents/styledComponents.js";
import { masterStyles } from "components/Styles/bankerMasterStyles";
import { tableShadow, globalStyles } from "components/Styles/globalStyles";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { IconButton, Popover, Button } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import URLs from "constants/urls";
export default function BankerMaster() {
  const [activeTab, setActiveTab] = useState(0);
  const [typeCode, setType] = useState("BL");
  const [selectedBankerName, setSelectedBankerName] = useState("");
  const [finainacialInstitutionCode, setfinainacialInstitutionCode] = useState("");
  const [selectedLoanType, setSelectedLoanType] = useState("");
  const [grossPayout, setGrossPayout] = useState("");
  const [tdsDeduction, setTdsDeduction] = useState("");
  const [dsaPercentOnPayout, setDsaPercentOnPayout] = useState("");
  const [selectedStreet, setSelectedStreet] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState("");
  const [selectedEmailID, setSelectedEmailID] = useState("");
  const [selectedContactPerson, setSelectedContactPerson] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [loanData, setLoanData] = useState([]);
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [financeIdBanker, setFinanceIdBanker] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteBankerId, setDeleteBankerId] = useState(0);
  const [deleteFinanceName, setDeleteFinanceName] = useState("");
  const [panNumber, setPanNumber] = useState("");
  const [gstNumber, setGstNumber] = useState("");
  const [productCode, setProductCode] = useState("");
  const [productName, setProductName] = useState("");
  const jwt_token = Cookie.get("jwt_token");
  const MInput = inputStyle();
  const [configAnchorEl, setConfigAnchorEl] = useState(null);
  const [configBusinessID, setConfigBusinessID] = useState("");
  const configPopoverOpen = Boolean(configAnchorEl);
  const handleConfigIconClick = (event) => {
    setConfigAnchorEl(event.currentTarget);
  };
  const handleConfigClose = () => {
    setConfigAnchorEl(null);
    setConfigBusinessID("");
  };

  const handleConfigSubmit = async () => {
    const data = {
      businessID: 0,
      type: serviceTypeCode,
      businessTypeCode: productCode,
      businessName: productName,
      activeStatus: "Y",
    };

    if (productCode && productName) {
      try {
        const response = await fetch(URLs.businessMaster, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt_token}`,
          },
          body: JSON.stringify(data),
        });

        if (response.ok) {
          handleConfigClose();
          getFinanceBusinessData();
          setAlert("Business added successfully");
          setProductCode("");
          setProductName("");
        } else {
          const errorText = await response.text();
          setAlert("Failed to add business", "error");
        }
      } catch (err) {
        setAlert("Something went wrong", "error");
      }
    } else {
      setAlert("Fill Product Name and Product Code", "error");
    }
  };

  const resetForm = () => {
    setSelectedBankerName("");
    setSelectedLoanType("");
    setPanNumber("");
    setGstNumber("");
    setGrossPayout("");
    setTdsDeduction("");
    setDsaPercentOnPayout("");
    setSelectedStreet("");
    setSelectedCity("");
    setSelectedState("");
    setSelectedPhoneNumber("");
    setSelectedEmailID("");
    setSelectedContactPerson("");
    setAlertMessage("");
    setSelectedBankerName("");
    setSelectedCity("");
    setSelectedStreet("");
    setSelectedPhoneNumber("");
    setSelectedState("");
    setSelectedEmailID("");
    setSelectedContactPerson("");
    setAlertMessage("");
    setfinainacialInstitutionCode("");
    setLoanData([]);
  };

  useEffect(() => {
    const selected = bussinessMasterData.find((item) => item.businessID === selectedLoanType);
    setSelectedLoanType(selected ? selected.businessID : ""); // Set the selected loan type based on selectedLoanType
  }, [selectedLoanType]);
  const serviceTypeOptions = [
    { label: "Loan", value: "BL" },
    { label: "Insurance", value: "IN" },
    { label: "Mutual Fund", value: "MF" },
  ];
  const [serviceType, setServiceType] = useState("BL");
  const [serviceTypeCode, setServiceTypeCode] = useState("BL");
  const changeService = () => {
    setServiceType(serviceTypeCode);
  };
  const {
    tableData,
    bussinessMasterData,
    isEditMode,
    open,
    alertType,
    message,
    loading,
    setLoading,
    handleClose,
    setAlert,
    setIsEditMode,
    fetchFinancesDataApiCall,
    postFinanceDataApiCall,
    deleteFinanceApiCall,
    putFinanceDataApiCall,
    getFinanceBusinessData,
  } = useMasterApiCall(serviceType, resetForm);

  useEffect(() => {
    fetchFinancesDataApiCall();
    getFinanceBusinessData();
  }, [fetchFinancesDataApiCall, getFinanceBusinessData]);

  const getBankerDataApiCall = (rowData) => {
    setActiveTab(1);
    setIsEditMode(true);
    setSelectedBankerName(rowData.finainacialInstitutionName);
    setPanNumber(rowData.pan);
    setGstNumber(rowData.gst);
    setSelectedStreet(rowData.address.street);
    setSelectedCity(rowData.address.city);
    setSelectedState(rowData.address.state);
    setSelectedPhoneNumber(rowData.phoneNumber);
    setSelectedEmailID(rowData.emailId);
    setSelectedContactPerson(rowData.contactPerson);
    setType(rowData.type);
    setLoanData(rowData.businessConfigs);
    setFinanceIdBanker(rowData.finananceId);
    setfinainacialInstitutionCode(rowData.financialInsitutionCode);
  };

  const postBankerDataApiCall = () => {
    const financeData = {
      finananceId: parseInt(0),
      finainacialInstitutionName: selectedBankerName,
      financialInsitutionCode: finainacialInstitutionCode,
      type: typeCode,
      contactPerson: selectedContactPerson,
      phoneNumber: selectedPhoneNumber,
      emailId: selectedEmailID,
      gst: gstNumber,
      pan: panNumber,
      address: {
        street: selectedStreet,
        city: selectedCity,
        state: selectedState,
      },
      businessConfigs: loanData.map((loan) => ({
        configId: parseInt(0),
        businessId: parseInt(loan.businessId),
        grossPayOut: parseFloat(loan.grossPayOut),
        tdsdeductionPercent: parseFloat(loan.tdsdeductionPercent),
        dsaPayOut: parseFloat(loan.dsaPayOut),
      })),
    };
    postFinanceDataApiCall(financeData, setActiveTab);
  };
  // 2. PUT Request to update existing banker data
  const putBankerDataApiCall = async (bankerFinanceId) => {
    const financeData = {
      finananceId: parseInt(bankerFinanceId),
      finainacialInstitutionName: selectedBankerName,
      financialInsitutionCode: finainacialInstitutionCode,
      type: typeCode,
      contactPerson: selectedContactPerson,
      phoneNumber: selectedPhoneNumber,
      emailId: selectedEmailID,
      gst: gstNumber,
      pan: panNumber,
      address: {
        street: selectedStreet,
        city: selectedCity,
        state: selectedState,
      },
      businessConfigs: loanData.map((loan) => ({
        configId: parseInt(loan.configId),
        businessId: parseFloat(loan.businessId),
        grossPayOut: parseFloat(loan.grossPayOut),
        tdsdeductionPercent: parseFloat(loan.tdsdeductionPercent),
        dsaPayOut: parseFloat(loan.dsaPayOut),
      })),
    };
    putFinanceDataApiCall(bankerFinanceId, financeData, setActiveTab);
  };

  const handleSave = (event) => {
    event.preventDefault();
    // Validate the required fields
    if (!selectedBankerName.trim() || loanData.length === 0) {
      // Set the alert message if validation fails
      setAlertMessage("Banker Name required, and there must be at least one policy entry.");
      return;
    }

    if (isEditMode) {
      putBankerDataApiCall(financeIdBanker);
    } else {
      postBankerDataApiCall();
    }
  };
  const handleDeleteLoanTypeRow = (event, rowIndex) => {
    event.preventDefault();
    event.stopPropagation();
    const updatedLoanData = loanData.filter((_, index) => index !== rowIndex);
    setLoanData(updatedLoanData);
  };

  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    const rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;
    const handleEdit = () => {
      // Call handleEditMutualFundRow with the rowIndex
      getBankerDataApiCall(rowData);
    };
    const handleDelete = () => {
      setOpenDialog(true);
      setDeleteBankerId(rowData.finananceId);
      setDeleteFinanceName(rowData.finainacialInstitutionName);
    };
    return (
      <div>
        <ViewButton type="button" onClick={handleEdit}>
          <EditIcon />
        </ViewButton>
        <DeleteButton type="button" onClick={handleDelete}>
          <DeleteIcon />
        </DeleteButton>
      </div>
    );
  };
  const handleLoanData = () => {
    if (dsaPercentOnPayout && tdsDeduction && grossPayout && selectedLoanType) {
      // Create new loan data object
      const newLoanData = {
        dsaPayOut: dsaPercentOnPayout,
        tdsdeductionPercent: tdsDeduction,
        grossPayOut: grossPayout,
        businessId: selectedLoanType,
      };
      console.log(newLoanData);

      // Check if the loan type already exists in the loanData
      const loanTypeExists = loanData.some((loan) => loan.businessId === selectedLoanType);
      if (loanTypeExists) {
        // Show an alert if the loan type is already present
        setAlert("Loan type already exists.");
      } else {
        // Add new data to loanData if the loan type is unique
        setLoanData([newLoanData, ...loanData]);
        // Reset form fields
        setDsaPercentOnPayout("");
        setSelectedLoanType("");
        setGrossPayout("");
        setTdsDeduction("");
      }
    } else {
      setAlert("Please fill in all fields", "error");
    }
  };
  const columnDefs = [
    {
      headerName: "Banker Name",
      field: "finainacialInstitutionName",
      filter: true,
      sortable: true,
      minWidth: 150,
      flex: 1,
    },
    {
      headerName: "Loan Types",
      field: "businessConfigs",
      minWidth: 150,
      flex: 3,
      filter: true,
      sortable: true,
      cellRenderer: (params) => {
        // Extract the businessConfigs array from the row data
        const businessConfigs = params.value || [];

        // Map businessConfigs to business names
        const loanTypes = businessConfigs
          .map((config) => {
            // Find the corresponding business data based on businessId
            const business = bussinessMasterData.find(
              (item) => item.businessID === config.businessId
            );
            return business ? business.businessName : "Unknown Business";
          })
          .join(", "); // Join the names with commas

        // Render the loan types as a span element
        return <span>{loanTypes}</span>;
      },
    },
    {
      headerName: "Actions",
      cellRenderer: ActionCellRenderer, // Assuming you have this renderer
      maxWidth: 100,
    },
  ];
  const resetFormState = () => {
    resetForm();
    setIsEditMode(false);
  };
  const formatInputValue = (value) => {
    return value.replace(/^\s+|\s+$/g, " ").replace(/\s+/g, " ");
  };

  function handleConfirmDelete() {
    deleteFinanceApiCall(deleteBankerId);
    setTimeout(() => {
      setOpenDialog(false);
    }, 1000);
  }
  const options = [
    { label: "Loans", value: "BL" },
    { label: "Insurance", value: "IN" },
    { label: "Mutual Fund", value: "MF" },
  ];

  const handleChange = (_, newValue) => {
    if (newValue) {
      setType(newValue.value);
    }
  };
  const tabs = [{ label: "Business Partners List" }, { label: "Create Business Partner" }];
  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <Dialog open={openDialog}>
        <DialogContent sx={subDialogContentStyle}>
          <DialogContentText sx={dialogContentTextStyle}>
            {`Are you sure you want to delete ${deleteFinanceName}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={masterStyles.dialogActions}>
          <StyledButton onClick={handleConfirmDelete}>Yes</StyledButton>
          <StyledButton onClick={() => setOpenDialog(false)} variant="outlined">
            No
          </StyledButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      <StyledTableContainer>
        <ResponsiveTabs
          tabs={tabs}
          activeTab={activeTab}
          onChange={handleChangeTab}
          labelColor="secondary"
          bgColor="#e0f7fa"
        />
        {activeTab === 0 && (
          <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-start", mt: 2 }}>
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              justifyContent="flex-start"
              flexWrap="wrap"
              sx={{
                width: "100%",
                maxWidth: "600px",
              }}
            >
              <Autocomplete
                options={serviceTypeOptions}
                getOptionLabel={(option) => option.label}
                value={
                  serviceTypeOptions.find((option) => option.value === serviceTypeCode) || null
                }
                onChange={(_, newValue) => setServiceTypeCode(newValue?.value || "")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Service Type"
                    variant="outlined"
                    fullWidth
                    sx={{
                      height: 42,
                      ...MInput.b,
                      width: "100%",
                      minWidth: "170px",
                      maxWidth: "300px", // Limit width on larger screens
                      "& .MuiInputBase-root": {
                        height: "100%",
                      },
                    }}
                    InputLabelProps={{
                      sx: {
                        color: MInput.a, // Ensure this applies to the label
                        "&.Mui-focused": {
                          color: "red", // Focused label color
                        },
                      },
                    }}
                  />
                )}
              />
              <StyledButton sx={{ height: 42, whiteSpace: "nowrap" }} onClick={changeService}>
                Get
              </StyledButton>
            </Stack>
          </Box>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            borderRadius: "12px",
            height: "100%",
            minHeight: 0,
            overflow: "auto",
            flexGrow: 1,
            mt: 2,
            boxShadow: "none",
            border: "none",
            backgroundColor: "#ffffff",
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
            }}
          >
            {activeTab === 0 && (
              <StyledAgGridContainer component={Paper} className={`ag-theme-alpine`}>
                <AgGridReact
                  rowData={tableData}
                  columnDefs={columnDefs}
                  pagination={true}
                  paginationPageSize={11}
                />
              </StyledAgGridContainer>
            )}
            {activeTab === 1 && (
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <Box
                    sx={{
                      height: "100%",
                      backgroundColor: "#FFFFFF",
                      borderRadius: "15px",
                      padding: 2,
                    }}
                  >
                    <div style={masterStyles.divStyle}>
                      <StyledTypography>
                        {!isEditMode ? "Provider Form" : "Edit Entry Details"}
                      </StyledTypography>
                      {isEditMode && (
                        <Tooltip title="Reset">
                          <StyledButtonC onClick={resetFormState}>
                            <RestartAltIcon />
                          </StyledButtonC>
                        </Tooltip>
                      )}
                    </div>
                    <form onSubmit={handleSave} autoComplete="off">
                      <Box p={{ sm: 1, md: 2 }} pt={{ xs: 3, sm: 2 }}>
                        <Grid container spacing={1}>
                          <Grid item xs={12} md={4} lg={1.5}>
                            <Autocomplete
                              options={options}
                              getOptionLabel={(option) => option.label}
                              value={options.find((option) => option.value === typeCode) || null}
                              onChange={handleChange}
                              PaperComponent={CustomPaper}
                              disableClearable={false}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Type"
                                  sx={{
                                    height: 43,
                                    ...MInput.b,
                                    "& .MuiInputBase-root": {
                                      height: "100%",
                                      minHeight: 43,
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      color: MInput.a, // Ensure this applies to the label
                                      "&.Mui-focused": {
                                        color: "red", // Focused label color
                                      },
                                    },
                                  }}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={3}>
                            <TextField
                              label="Provider Name"
                              required
                              fullWidth
                              value={selectedBankerName}
                              onChange={(e) =>
                                setSelectedBankerName(formatInputValue(e.target.value))
                              }
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="Provider Code"
                              required
                              fullWidth
                              value={finainacialInstitutionCode}
                              onChange={(e) => setfinainacialInstitutionCode(e.target.value.trim())}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="PAN"
                              // required
                              fullWidth
                              value={panNumber}
                              onChange={(e) => setPanNumber(e.target.value.trim())}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="GST Number"
                              // required
                              fullWidth
                              value={gstNumber}
                              onChange={(e) => setGstNumber(e.target.value.trim())}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={1.5}>
                            <TextField
                              label="Phone Number"
                              fullWidth
                              type="tel"
                              onChange={(e) => {
                                const phoneNumberPattern = /^[1-9]\d{9}$/; // Example for Indian numbers
                                const value = e.target.value;
                                setSelectedPhoneNumber(value);
                                setPhoneNumberError(!phoneNumberPattern.test(value));
                              }}
                              value={selectedPhoneNumber}
                              error={phoneNumberError} // Display error if phone number is invalid
                              helperText={
                                phoneNumberError ? "Please enter a valid phone number" : ""
                              }
                              inputProps={{
                                maxLength: 10, // Restrict to 10 digits for phone numbers
                                pattern: "[1-9]{1}[0-9]{9}",
                              }}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={3}>
                            <TextField
                              label="Contact Person Name"
                              fullWidth
                              type="text"
                              onChange={(e) =>
                                setSelectedContactPerson(formatInputValue(e.target.value))
                              }
                              value={selectedContactPerson}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={1.5}>
                            <TextField
                              label="Email ID"
                              fullWidth
                              type="email"
                              value={selectedEmailID}
                              onChange={(e) => setSelectedEmailID(formatInputValue(e.target.value))}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="Street"
                              fullWidth
                              value={selectedStreet}
                              onChange={(e) => setSelectedStreet(formatInputValue(e.target.value))}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="City"
                              fullWidth
                              value={selectedCity}
                              onChange={(e) => setSelectedCity(formatInputValue(e.target.value))}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} md={4} lg={2}>
                            <TextField
                              label="State"
                              fullWidth
                              value={selectedState}
                              onChange={(e) => setSelectedState(formatInputValue(e.target.value))}
                              sx={MInput.b}
                              InputLabelProps={{
                                sx: {
                                  color: MInput.a,
                                },
                              }}
                            />
                          </Grid>
                        </Grid>
                        <TableContainer sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
                          <Table
                            sx={{
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              minWidth: "900px",
                              tableLayout: "fixed",
                            }}
                          >
                            <TableBody>
                              <TableRow>
                                {[
                                  "Select Product",
                                  "Gross Payout %",
                                  "TDS Deduction %",
                                  "DSA Payout %",
                                  "Action",
                                ].map((header, index) => (
                                  <CustomTableCell
                                    key={index}
                                    sx={{
                                      minWidth: index === 0 ? 200 : 100,
                                      fontWeight: "bold",
                                      backgroundColor: "#f8f8f8",
                                      padding: "8px",
                                      position: index === 4 ? "sticky" : "static", // Fix last column
                                      right: index === 4 ? 0 : "auto", // Fix position on the right
                                      background: "#f8f8f8", // Ensure background for sticky column
                                      zIndex: index === 4 ? 2 : 1,
                                    }}
                                  >
                                    {header}
                                  </CustomTableCell>
                                ))}
                              </TableRow>

                              <TableRow>
                                <TableCell>
                                  <Autocomplete
                                    options={bussinessMasterData}
                                    getOptionLabel={(option) => option.businessName}
                                    value={
                                      bussinessMasterData.find(
                                        (item) => item.businessID === selectedLoanType
                                      ) || null
                                    }
                                    onChange={(event, value) =>
                                      setSelectedLoanType(value?.businessID || "")
                                    }
                                    filterOptions={(options, state) => {
                                      const input = state.inputValue.toLowerCase();
                                      const startsWith = options.filter((o) =>
                                        o.businessName.toLowerCase().startsWith(input)
                                      );
                                      const contains = options.filter(
                                        (o) =>
                                          !o.businessName.toLowerCase().startsWith(input) &&
                                          o.businessName.toLowerCase().includes(input)
                                      );
                                      return [...startsWith, ...contains];
                                    }}
                                    PaperComponent={CustomPaper}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        placeholder="Product Type"
                                        variant="outlined"
                                        fullWidth
                                        sx={{
                                          minWidth: 200,
                                          height: 43,
                                          ...MInput.b,
                                          "& .MuiInputBase-root": {
                                            height: "100%",
                                            minHeight: 43,
                                          },
                                        }}
                                        InputProps={{
                                          ...params.InputProps,
                                          endAdornment: (
                                            <>
                                              {params.InputProps.endAdornment}
                                              <IconButton
                                                size="small"
                                                onClick={handleConfigIconClick}
                                                sx={{ ml: 0.5 }}
                                              >
                                                <SettingsIcon fontSize="small" />
                                              </IconButton>
                                            </>
                                          ),
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            color: MInput.a,
                                            "&.Mui-focused": {
                                              color: "red",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </TableCell>

                                {[grossPayout, tdsDeduction, dsaPercentOnPayout].map(
                                  (value, index) => (
                                    <TableCell key={index}>
                                      <TextField
                                        type="text"
                                        fullWidth
                                        value={value}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          if (/^\d{0,3}(\.\d{0,3})?$/.test(val)) {
                                            if (index === 0) setGrossPayout(val);
                                            if (index === 1) setTdsDeduction(val);
                                            if (index === 2) setDsaPercentOnPayout(val);
                                          }
                                        }}
                                        placeholder="000.00"
                                        sx={{ padding: "8px", fontSize: "14px" }}
                                      />
                                    </TableCell>
                                  )
                                )}

                                <TableCell
                                  sx={{
                                    position: "sticky",
                                    right: 0,
                                    background: "#f8f8f8",
                                    zIndex: 2,
                                  }}
                                >
                                  <ViewButton
                                    type="button"
                                    onClick={handleLoanData}
                                    sx={{ minWidth: "40px" }}
                                  >
                                    <AddTaskIcon />
                                  </ViewButton>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <TableContainer sx={{ mt: 2, width: "100%", overflowX: "auto" }}>
                          <Table
                            sx={{
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              minWidth: "900px",
                              tableLayout: "fixed",
                            }}
                          >
                            <TableBody>
                              <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                                {[
                                  "Loan Type",
                                  "Gross Payout %",
                                  "TDS Deduction %",
                                  "DSA Payout %",
                                  "Action",
                                ].map((header, index) => (
                                  <CustomTableCell
                                    key={index}
                                    sx={{
                                      minWidth: index === 0 ? 200 : 100,
                                      fontWeight: "bold",
                                      backgroundColor: "#f8f8f8",
                                      padding: "8px",
                                      position: index === 4 ? "sticky" : "static", // Fix last column
                                      right: index === 4 ? 0 : "auto", // Fix position on the right
                                      background: "#f8f8f8", // Ensure background for sticky column
                                      zIndex: index === 4 ? 2 : 1,
                                    }}
                                  >
                                    {header}
                                  </CustomTableCell>
                                ))}
                              </TableRow>
                              {loanData.length > 0 ? (
                                loanData.map((item, index) => (
                                  <TableRow key={index}>
                                    <CustomTableCell sx={{ minWidth: 200 }}>
                                      {bussinessMasterData.find(
                                        (each) => each.businessID === item.businessId
                                      )?.businessName || "Unknown"}
                                    </CustomTableCell>
                                    <CustomTableCell sx={{ minWidth: 200 }}>
                                      {item.grossPayOut}
                                    </CustomTableCell>
                                    <CustomTableCell sx={{ minWidth: 200 }}>
                                      {item.tdsdeductionPercent}
                                    </CustomTableCell>
                                    <CustomTableCell sx={{ minWidth: 200 }}>
                                      {item.dsaPayOut}
                                    </CustomTableCell>
                                    <CustomTableCell
                                      sx={{
                                        minWidth: 150,
                                        position: "sticky",
                                        right: 0,
                                        backgroundColor: "#f8f8f8",
                                        zIndex: 2,
                                      }}
                                    >
                                      <DeleteButton
                                        onClick={(e) => handleDeleteLoanTypeRow(e, index)}
                                      >
                                        <DeleteIcon />
                                      </DeleteButton>
                                    </CustomTableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow>
                                  <CustomTableCell
                                    colSpan={5}
                                    align="center"
                                    sx={{ padding: "10px", fontWeight: "500" }}
                                  >
                                    No data available
                                  </CustomTableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <Grid sx={masterStyles.buttonDivStyle}>
                          <StyledButton type="submit"> Save</StyledButton>
                        </Grid>
                      </Box>
                    </form>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Box>
        </Box>
        <Popover
          open={configPopoverOpen}
          anchorEl={configAnchorEl}
          onClose={handleConfigClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Box
            sx={{
              p: 2,
              minWidth: 250,
              backgroundColor: "#fefefe",
              borderRadius: 1,
              boxShadow: 3,
            }}
          >
            <Typography variant="body1" fontWeight="bold" gutterBottom sx={{ fontSize: "14px" }}>
              Add a New Product
            </Typography>
            <TextField
              label="Product Name"
              fullWidth
              type="text"
              onChange={(e) => setProductName(formatInputValue(e.target.value))}
              value={productName}
              sx={{ ...MInput.b, mb: 2 }} // Adds spacing below this field
              InputLabelProps={{
                sx: {
                  color: MInput.a,
                },
              }}
            />

            <TextField
              label="Product Code"
              fullWidth
              type="text"
              onChange={(e) => setProductCode(formatInputValue(e.target.value))}
              value={productCode}
              sx={MInput.b}
              InputLabelProps={{
                sx: {
                  color: MInput.a,
                },
              }}
            />

            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button onClick={handleConfigClose} size="small">
                Cancel
              </Button>
              <StyledButton
                onClick={handleConfigSubmit}
                size="small"
                variant="contained"
                sx={{ ml: 1 }}
              >
                Submit
              </StyledButton>
            </Box>
          </Box>
        </Popover>
      </StyledTableContainer>
    </DashboardLayout>
  );
}
BankerMaster.propTypes = {
  data: PropTypes.object.isRequired,
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  uuid: PropTypes.string.isRequired, // Add uuid to propTypes
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
